module.exports = __webpack_public_path__ + "img/poster_action_map_.dfab6233.jpg";